import { render, staticRenderFns } from "./HeaderAMP.vue?vue&type=template&id=491967e2&scoped=true&"
import script from "./HeaderAMP.vue?vue&type=script&lang=js&"
export * from "./HeaderAMP.vue?vue&type=script&lang=js&"
import style0 from "./HeaderAMP.vue?vue&type=style&index=0&id=491967e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491967e2",
  null
  
)

export default component.exports